import React, { useState } from 'react';
import { Twitter, Instagram, Facebook, MessageSquare } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FeedbackDialog } from '../feedback/FeedbackDialog';

export const Footer: React.FC = () => {
  const [showFeedback, setShowFeedback] = useState(false);

  return (
    <>
      <footer className="bg-gray-800 dark:bg-gray-900 text-white py-12 mt-auto transition-colors">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Logo and Description */}
            <div className="text-center mb-10">
              <h2 className="text-2xl font-bold mb-3">Banga.ai</h2>
              <p className="text-gray-300 max-w-xl mx-auto text-sm">
                AI-powered soccer predictions and in-depth match analysis to help you make smarter betting decisions.
              </p>
            </div>

            {/* Links Grid */}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-8 justify-items-center mb-10">
              {/* Quick Links */}
              <div className="text-center">
                <h3 className="text-sm font-semibold uppercase tracking-wider mb-4">Quick Links</h3>
                <ul className="space-y-3">
                  <li>
                    <Link 
                      to="/" 
                      className="text-gray-300 hover:text-white transition-colors text-sm"
                    >
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link 
                      to="/why-banga" 
                      className="text-gray-300 hover:text-white transition-colors text-sm"
                    >
                      Why Banga
                    </Link>
                  </li>
                  <li>
                    <Link 
                      to="/markets" 
                      className="text-gray-300 hover:text-white transition-colors text-sm"
                    >
                      Markets
                    </Link>
                  </li>
                  <li>
                    <button
                      onClick={() => setShowFeedback(true)}
                      className="text-gray-300 hover:text-white transition-colors text-sm flex items-center justify-center mx-auto gap-1.5"
                    >
                      <MessageSquare className="w-4 h-4" />
                      Feedback
                    </button>
                  </li>
                </ul>
              </div>

              {/* Legal */}
              <div className="text-center">
                <h3 className="text-sm font-semibold uppercase tracking-wider mb-4">Legal</h3>
                <ul className="space-y-3">
                  <li>
                    <Link 
                      to="/privacy" 
                      className="text-gray-300 hover:text-white transition-colors text-sm"
                    >
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link 
                      to="/terms" 
                      className="text-gray-300 hover:text-white transition-colors text-sm"
                    >
                      Terms & Conditions
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Social */}
              <div className="text-center col-span-2 md:col-span-1">
                <h3 className="text-sm font-semibold uppercase tracking-wider mb-4">Follow Us</h3>
                <div className="flex justify-center space-x-4">
                  <a 
                    href="https://x.com/banga.ai" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-white transition-colors p-2 hover:bg-gray-700 rounded-full"
                    aria-label="Follow us on X (Twitter)"
                  >
                    <Twitter className="w-5 h-5" />
                  </a>
                  <a 
                    href="https://www.instagram.com/banga.ai/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-white transition-colors p-2 hover:bg-gray-700 rounded-full"
                    aria-label="Follow us on Instagram"
                  >
                    <Instagram className="w-5 h-5" />
                  </a>
                  <a 
                    href="https://www.facebook.com/RealBangaAI" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-white transition-colors p-2 hover:bg-gray-700 rounded-full"
                    aria-label="Follow us on Facebook"
                  >
                    <Facebook className="w-5 h-5" />
                  </a>
                </div>
              </div>
            </div>

            {/* Copyright */}
            <div className="text-center pt-8 border-t border-gray-700">
              <p className="text-sm text-gray-400">
                &copy; {new Date().getFullYear()} Tripple O Solutions. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>

      <FeedbackDialog 
        isOpen={showFeedback} 
        onClose={() => setShowFeedback(false)} 
      />
    </>
  );
};